<template>
    <div class="radar-tarja">
      <div class="radar-tarja__shift" :style="cardStyle">
        <svg class="radar-tarja__art" viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid meet">
            <polygon points="57,869 1260,869 1212,1018 9,1018" fill="#05A347" stroke="#05A347" stroke-width="1" stroke-linejoin="round" />
            <polygon points="21,868 57,868 37,930" fill="#1829C2" stroke="#1829C2" stroke-width="1" stroke-linejoin="round" />
            <polygon points="46,788 639,788 614,868 21,868" fill="#2000F6" stroke="#2000F6" stroke-width="1" stroke-linejoin="round" />

            <!-- YouTube badge — gold ring + red circle + white play, in the gap right of the blue bar (YouTube only) -->
            <g v-if="isYoutube">
                <circle cx="694" cy="825.5" r="31" fill="#F6ED0C" />
                <g transform="translate(667 798.5) scale(0.18)">
                    <rect width="300" height="300" ry="150" fill="#FF0000" />
                    <path fill="#FFFFFF" d="M149.93750587 79.22267364s-63.21885.000059-79.08593926 4.12304707c-8.49578714 2.37380204-15.49140825 9.36950015-17.86523429 17.99023729-4.12295306 15.86710025-4.12304706 48.72656078-4.12304706 48.72656078s.000094 32.98420052 4.12304706 48.60156077c2.37382604 8.62062014 9.24450615 15.49138025 17.86523429 17.86524029 15.99203025 4.24788007 79.08593926 4.24804007 79.08593926 4.24804007s63.34418101-.00005 79.21094127-4.12304007c8.62079014-2.37381004 15.49133025-9.11966015 17.74023028-17.86524029 4.24793007-15.74232025 4.24805007-48.60156077 4.24805007-48.60156077s.12484-32.98446053-4.24805007-48.85156078c-2.24890003-8.62073714-9.11944014-15.49133425-17.74023028-17.74023729-15.86676026-4.37284707-79.21094127-4.37304707-79.21094127-4.37304707zm-20.11523032 40.48046465 52.59961084 30.35938049-52.59961084 30.23438048v-60.59376097z" />
                </g>
            </g>
        </svg>

        <!-- Collaborator name — over the blue parallelogram -->
        <div class="radar-tarja__name">
            <span>{{ colabData?.dsc_nome_colaborador }}</span>
        </div>

        <!-- Collaboration text — over the green parallelogram -->
        <div class="radar-tarja__text">
            <span :style="{ fontSize: textFontSize }">{{ colabData.dsc_texto_colaboracao }}</span>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    props: {
        colabData: Object,
        posicaoCard: String,
    },
    computed: {
        cardStyle() {
            if (this.posicaoCard === "centro") return { transform: "translateX(17%)" };
            if (this.posicaoCard === "direita") return { transform: "translateX(31%)" };
            return {};
        },
        isYoutube() {
            return (this.colabData?.dsc_fonte_colaboracao || "").toLowerCase() === "youtube";
        },
        textFontSize() {
            const len = (this.colabData?.dsc_texto_colaboracao || "").trim().length;
            if (len <= 60) return "1.9vw";
            if (len <= 120) return "1.6vw";
            if (len <= 180) return "1.35vw";
            if (len <= 240) return "1.15vw";
            return "1vw";
        },
    },
};
</script>

<style lang="scss" scoped>
.radar-tarja {
    position: relative;
    width: 100%;
    height: 100vh; /* cap to viewport so the full-frame art never overflows (kills the scrollbar) */
    overflow: hidden; /* clip the transparent overflow + the horizontal posicaoCard shift */
}

.radar-tarja__shift {
    position: absolute;
    left: 0;
    bottom: 0; /* anchor the art to the bottom; excess height is clipped off the top */
    width: 100%;
}

.radar-tarja__art {
    display: block;
    width: 100%;
    height: auto;
    shape-rendering: geometricPrecision;
}

/* Name — over the blue parallelogram */
.radar-tarja__name {
    position: absolute;
    left: 4%;
    top: 73%;
    width: 27%;
    height: 7%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.radar-tarja__name span {
    max-width: 100%;
    color: #ffffff;
    font-weight: 800;
    font-size: 2.1vw;
    line-height: 1.1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Collaboration text — over the green parallelogram */
.radar-tarja__text {
    position: absolute;
    left: 4%;
    top: 81%;
    width: 60%;
    height: 13%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
}

.radar-tarja__text span {
    color: #ffffff;
    font-weight: 800;
    line-height: 1.25;
    overflow-wrap: anywhere;
}
</style>
